<template>
  <Modal
    v-model="openChakan"
    title="分派附近人员"
    footer-hide
    width="400"
    height="400"
    @on-cancel="cliclCancelBtn"
  >
    <Form ref="item" :model="item" :rules="ruleValidate" :label-width="120">
      <Row :gutter="16">
        <Col span="24">
          <FormItem label="查找范围/米" prop="remark">
            <Select v-model="radius" @on-change="drawCir">
              <Option v-for="(x, index) in metets" :value="x.id" :key="index">{{
                x.name
              }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="24">
          <FormItem label="分派人员" prop="userId">
            <Select v-model="item.userId" @on-select="selectuser">
              <Option
                v-for="(x, index) in tableData"
                :value="x.userId"
                :key="index"
                >{{ x.userName }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col span="24">
          <FormItem label="预计结案时间" prop="settleTime1">
            <DatePicker
              type="datetime"
              placeholder="选择日期"
              v-model="item.settleTime1"
            ></DatePicker>
          </FormItem>
        </Col>
        <Col span="24">
          <FormItem label="预计完成时间" prop="finishTime1">
            <DatePicker
              type="datetime"
              placeholder="选择日期"
              v-model="item.finishTime1"
            ></DatePicker>
          </FormItem>
        </Col>
        <Col span="24">
          <FormItem label="备注信息" prop="remark">
            <Input v-model="item.remark" placeholder="请输入"></Input>
          </FormItem>
        </Col>
        <Col span="24">
          <Button @click="paidan" type="primary" long>立即分派</Button>
        </Col>
      </Row>
    </Form>
  </Modal>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      openChakan: false,
      tableData: [],
      item: {
        userId: "",
        settleTime: "",
        settleTime1: new Date(),
        finishTime: "",
        finishTime1: new Date(),
        id: "",
        x: "",
        y: "",
      },
      metets: [
        { id: 500, name: "500米" },
        { id: 1000, name: "1000米" },
        { id: 1500, name: "1500米" },
        { id: 2000, name: "2000米" },
        { id: 5000, name: "5公里" },
        { id: 10000, name: "10公里" },
        { id: 20000, name: "20公里" },
        { id: 50000, name: "50公里" },
        { id: 100000, name: "100公里" },
        { id: 10000000, name: "不限" },
      ],
      ruleValidate: {
        settleTime1: { required: true, message: "必填" },
        finishTime1: { required: true, message: "必填" },
        userId: { required: true, message: "必填" },
      },
      radius: "",
    };
  },
  methods: {
    open(v) {
      this.openChakan = true;
      this.item.id = v.id;
      this.item.x = v.x;
      this.item.y = v.y;
      this.getList();
    },
    getList() {
      this.utils.loading(this, "加载中");
      var params = {
        x: this.item.x,
        y: this.item.y,
        radius: this.radius,
        pointType: 2,
      };
      console.log(params);
      axios({
        method: "post",
        url: axios.event + "/event/findNearbyUser",
        data: params,
      }).then((res) => {
        console.log(res);
        this.$Spin.hide(); //关闭加载
        var data = res.data.data;
        for (let i = 0; i < data.length; i++) {
          data[i].select = false;
        }
        this.tableData = data;
      });
    },
    paidan(v) {
      this.item.settleTime = this.utils.toSjc(this.item.settleTime1);
      this.item.finishTime = this.utils.toSjc(this.item.finishTime1);
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.event + "/event/assign",
        data: this.item,
      }).then((res) => {
        console.log(res);
        this.$Spin.hide(); //关闭加载
        if (res) {
          this.openChakan = false;
          this.$emit("success");
        }
      });
    },
    selectuser(v) {
      console.log(v);
      this.item.userName = v.label;
    },
    cliclCancelBtn() {},
    drawCir(v) {
      this.getList();
    },
  },
};
</script>
<style lang="">
#personList .ddseee {
  width: 120px;
  height: 4opx;
  background: #ccc;
  display: inline-block;
}
#personList .ddseeeactive {
  background: #2860fc !important;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/event/chakan.vue